export default __webpack_public_path__ + "static/media/featured-prof-mobile.b07682f8.png";